import CheckmarkWithHover from "./CheckMarkWithHover";

const NachTickHist = ({ data }) => {

    let date = "";
    
    if (data) {
        const nachDate = (data?.Details?.[354]?.Nach_hit_date || data?.Details?.[228]?.Nach_hit_date || data?.Details?.[376]?.Nach_hit_date)?.split("-") ?? ["", ""];
        date = `${nachDate[0].replace(/^0+/, "")}th`; // Remove leading zeros, e.g., '05' -> '5'
    }

    const serviceIds = [354, 228, 376];
    // Find the first available NACH amount
    const nachAmount = serviceIds
        .map(id => data?.Details?.[id]?.Nach_Amount)
        .find(amount => amount !== undefined);

    return (
        <div style={{ display: 'contents' }}>
            <span className="nach-date-amt">
                <span title='NACH due date'>{`${date || ""}`}</span>
                {` | Rs ${nachAmount && Math.ceil(nachAmount)}`}
            </span>
            {/* <span>
                {["354", "228", "376"]
                    .map(serviceId => data?.Details?.[serviceId]?.nach_history)
                    .find(history => history)?.slice(0, 6)
                    .reverse()
                    .filter(x => ["1", "2", "3", "4", "5", "6", "7"].includes(x.nach_status))
                    .map((x, index) => (
                        <CheckmarkWithHover key={index} status={x.nach_status} dateStr={x.ar_recpt_date} />
                    ))}
            </span> */}
        </div>
    )
};

export default NachTickHist;